@if (Status === 'Accepted' || Status === 'AcceptedAlert') {
  <div [ngClass]="{ 'by-other': IsAcceptedByOther }">
    <span
      >Accepted by
      <span class="link-text" (click)="goToEditUserAccess(params.data.acceptedByUser)">{{
        params?.data?.acceptedByUserName
      }}</span>
    </span>
    @if (IsAcceptedByOther) {
      <div
        class="status-icon other-email"
        [raUiTooltip]="'Does not match invited email: ' + params?.data?.toEmail"
        [tooltipConfig]="tooltipConfig"
      >
        <i class="ra-icon-ide-md-color-warning"></i>
        <span>{{ params?.data?.acceptedByEmail }}</span>
      </div>
    }
  </div>
} @else {
  @if (Status === 'Active') {
    <span> {{ getExpiryDuration(params?.data?.expiry) }} </span>
  }
  @if (Status !== 'Active') {
    <span>{{ getInvitationStatus(params?.value) }}</span>
  }
}
